import React, { Component } from "react";
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types';
import { Link, BrowserRouter as Router, NavLink as RouterNavLink } from "react-router-dom";
import { connect } from "react-redux";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";
import PermissionAlert from "../../components/Common/permissionalert";
import RsCard from "components/Rscards/Rscard";
import RSPieChart from "components/charts/RSPieChart";
import RSBarChart from "components/charts/RSBarChart";
import RsAdNew from "components/buttons/Adnew";
import classnames from "classnames";
import {
  Container, Row, Col, Card,
  Nav,
  NavItem,
  NavLink, Offcanvas, OffcanvasHeader, OffcanvasBody,
  CardBody
} from "reactstrap";
import axios from "axios";
import { API_URL } from "helpers/app_url";
import LeadlistShort from "./Leadlist-short";
import Moment from "react-moment";
import CreateLead from './forms/lead-create'
import leadImg from "../../assets/img/l-1.png"
import hotImg from "../../assets/img/l-2.png"
import warmImg from "../../assets/img/l-3.png"
import coldImg from "../../assets/img/l-4.png"
import notImg from "../../assets/img/l-5.png"
import RsCardImg from "components/Rscards/Rscard-img";
import RsAdNewV2 from "components/buttons/Adnew-v2";
import RsCardImgv2 from "components/Rscards/Rscard-imgv2";
import { hasPermission } from "helpers/checkPermission";
class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: '1',
      reports: [
        { title: "Leads in 2025", iconClass: leadImg, description: "loading...." },
        { title: "Hot leads", iconClass: hotImg, description: "loading...." },
        { title: "Warm Leads", iconClass: warmImg, description: "loading...." },
        { title: "Cold Leads", iconClass: coldImg, description: "loading...." },
        { title: "Not Set", iconClass: notImg, description: "loading...." },
      ],
      barchartdata: null,
      leadSourceData: null,
      error: null,
      upcomingActivities : []
    };
    this.toggleAddNew = this.toggleAddNew.bind(this);
  }
  addNewtoggle() {
    this.setState(prevState => ({
      isAddNew: !prevState.isAddNew
    }));
  }
  toggleAddNew() {
    this.setState({ isAddNew: !this.state.isAddNew });

  }
  componentDidMount() {
    this.fetchLeadDashboardMonthByAgent();
    this.fetchLeadSourceData();
    this.fetchLeadStageData();
    this.fetchAllLeadCounts(2025);
    this.fetchLeadActivity(1);
  }

  fetchLeadDashboardMonthByAgent = async () => {
    const agentId = localStorage.getItem("userId");
    const year = "2025";
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const url = `${API_URL}Lead/getLeadDashboardMonthByAgent?agentId=${agentId}&year=${year}`;

    try {
      const response = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });

      if (response.data) {
        const { months, counts } = response.data;
        this.setState({
          barchartdata: {
            series: [{ name: "Leads", data: counts }],
            options: {
              chart: { type: "bar", toolbar: { show: false } },
              plotOptions: { bar: { horizontal: false, columnWidth: "50%" } },
              dataLabels: { enabled: false },
              colors: ["#195772"],
              grid: { borderColor: "#f1f1f1" },
              xaxis: { categories: months },
              height:300,
              fill: { opacity: 1 },
              tooltip: { y: { formatter: (val) => `${val} Leads` } },
            },
          },
        });
      }
    } catch (error) {
      this.setState({ error: error.message });
    }
  };

  fetchLeadSourceData = async () => {
    const agentId = localStorage.getItem("userId");
    const year = "2025";
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const url = `${API_URL}Lead/getLeadSourceDashboardByAgent?agentId=${agentId}&year=${year}`;

    try {
      const response = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });
        if (response.data && Array.isArray(response.data)) {
      
          const sources = response.data.map(item => item.sources);
          const counts = response.data.map(item => parseInt(item.counts));
        this.setState({
          leadSourceData: {
            series: counts,
            options: {
              chart: { type: "pie" },
              labels: sources,
              colors: ["#004aad", "#ffbd59", "#cb6ce6", "#ff6d4d", "#14891c"],
              legend: {
                show: true,
                position: "bottom",
                horizontalAlign: "center",
                verticalAlign: "middle",
                floating: false,
                fontSize: "14px",
                offsetX: 0,
                offsetY: -10,
              },
              responsive: [
          {
            breakpoint: 992,
            options: {
              chart: {
                width: "100%",
                height: 320,
              },
              legend: {
                show: true,
                position: "bottom",
                fontSize: "12px",
              },
            },
          },
          {
            breakpoint: 600,
            options: {
              chart: {
                width: "100%",
                height: 280,
              },
              legend: {
                show: false, 
              },
              plotOptions: {
                pie: {
                  donut: {
                    labels: {
                      show: true,
                    },
                  },
                },
              },
            },
          },
        ],
            },
          },
        });
      }
    } catch (error) {
      this.setState({ error: error.message });
    }
  };

  fetchLeadStageData = async () => {
    const agentId = localStorage.getItem("userId");
    const year = "2025";
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const url = `${API_URL}Lead/getLeadStageDashboardByAgent?agentId=${agentId}&year=${year}`;
  
    try {
      const response = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });
  
      if (response.data && Array.isArray(response.data)) {
      
        const sources = response.data.map(item => {
        
          return item.sources || "Unknown";
        });
  
        const counts = response.data.map(item => {
     
          return item.counts !== null && item.counts !== undefined ? item.counts : 0;
        });
  
       
        const hasValidCounts = counts.some(count => count > 0);
        
        this.setState({
          leadStageData: {
            series: [1,2,1],
            options: {
              chart: { type: "pie" },
              labels:['Junk', 'Lost to another agent', 'Not interested'],
              colors: ["#66C2A5", "#FFD92F", "#A6D854", "#E78AC3"],
              legend: {
                show: true,
                position: "bottom",
                horizontalAlign: "center",
                verticalAlign: "middle",
                floating: false,
                fontSize: "14px",
                offsetX: 0,
                offsetY: -10,
              },
              responsive: [{ 
                breakpoint: 600, 
                options: { 
                  chart: { height: 440 }, 
                  legend: { show: false } 
                } 
              }],
            },
          },
        });
      } else {
        this.setState({
          leadStageData: {
            series: [1],
            options: {
              chart: { type: "pie" },
              labels: ["No Data"],
              colors: ["#CCCCCC"],
            },
          },
        });
      }
    } catch (error) {
      console.error("Error fetching lead stage data:", error);
      this.setState({ error: error.message });
    }
  };
  
  fetchAllLeadCounts = async (year) => {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const str = `Bearer ${token}`;

    try {
        const response = await axios.get(`${API_URL}Lead/getLeadCountDashboardByAgent`, {
            params: {
                agentId: localStorage.getItem("userId"),
                year: year
            },
            headers: { Authorization: str }
        });

        if (response.data && Array.isArray(response.data)) {
            const totalItem = response.data.find(item => item.sources === "Total") || {};

          const generatedLeads = Number(totalItem.counts) || 0;
          const convertedLeads = Number(totalItem.counts2) || 0;
          const activeLeads    = Number(totalItem.counts1) || 0;

          const conversionRate = generatedLeads > 0
            ? ((convertedLeads / generatedLeads) * 100).toFixed(2)
            : "0";
            const hotLeads = response.data.find(item => item.sources === "Hot")?.counts || 0;
            const warmLeads = response.data.find(item => item.sources === "Warm")?.counts || 0;
            const coldLeads = response.data.find(item => item.sources === "Cold")?.counts || 0;
            const notSetLeads = response.data.find(item => item.sources === "Not Set")?.counts || 0;
             this.setState({
                generatedLeads,
                convertedLeads,
                activeLeads,
                conversionRate,
                hotLeads,
                warmLeads,
                coldLeads,
                notSetLeads
            });
           
           
        }
    } catch (error) {
        console.error("Error fetching lead counts:", error);
    }
};

fetchLeadActivity = async (days) => {
  const obj = JSON.parse(localStorage.getItem("authUser"));
  const token = obj?.resultData?.bearerToken;
  const str = `Bearer ${token}`;

  const payload = {
    activityTypeId: [0],
    agentId: parseInt(localStorage.getItem("userId")),
    category: 3,
    days: days
  };

  try {
    const response = await axios.post(
      `${API_URL}LeadActivity/allfilteredleadactivitiesbydate`,
      payload,
      {
        headers: { Authorization: str }
      }
    );

    if (response.data) {
      this.setState({ leadActivities: response.data });
    }
  } catch (error) {
    console.error("Error fetching lead activities:", error);
  }
};

toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }
  render() {
  const { userdetail } = this.props;
  const { activeTab,    generatedLeads, convertedLeads,
                activeLeads,
                conversionRate,
                hotLeads,
                warmLeads,
                coldLeads,
                notSetLeads } = this.state;

  const userModule = localStorage.getItem('userModule');
  // if (userModule.indexOf("BrokerAgent.RealtorLeadsDashboard.View") === -1) {
  //   return <PermissionAlert />;
  // }

    return (
      <React.Fragment>
        <div className="page-content project-page-content">
          <MetaTags>
            <title>Lead Dashboard | Realty Space</title>
          </MetaTags>
          <Container fluid>
            <Row className="project-header">
              <Col xl="7">
                <Breadcrumbs title={this.props.t("Lead")} breadcrumbItem={this.props.t("Leads Dashboard")} />
              </Col>
              <Col xl="5">
               <div className="pt-2 mt-2 d-flex justify-content-center justify-content-xl-end flex-wrap">
                  {hasPermission("RealtorLeads", "Add") && (
                  <RsAdNewV2 to="/lead/eligibility/overview" iconClass="bx bx-right-arrow-alt" className="text-purple border-right">
                      Lead eligibility criteria 
                  </RsAdNewV2>
                  )}
                  
                   {hasPermission("RealtorLeads", "Add") && (
                  <RsAdNewV2 to="#" onClick={this.toggleAddNew} className="text-purple border-right" iconClass="bx bx-plus-medical">Add new</RsAdNewV2>
                   )}
                  {" "}
                   <div className="d-none d-md-inline">
                      {hasPermission("RealtorLeads", "Add") && (
                  <RsAdNewV2 to="/lead/import-lead" className="text-purple" iconClass=" bx bx-upload font-size-18">
                    Import leads
                  </RsAdNewV2>
                      )}
                  </div>
                </div>
              </Col>
            </Row>
           
          
<Row className="mt-4 justify-content-center">
  {/* Leads Card */}
  <Col md="6" className="mb-3">
    <Card className="h-100">
      <CardBody className="d-flex align-items-center justify-content-center text-center">
        {/* Hide image on mobile */}
        <img 
          src={leadImg} 
          alt="leads" 
          style={{ height: 60 }} 
          className="me-3 d-none d-md-block" 
        />
        <div>
          <h5 className="fw-bold mb-1 font-size-20">Leads ({new Date().getFullYear()})</h5>
          <div className="d-flex flex-wrap justify-content-center gap-3 rs-status-text">
            <span>Generated : <strong>{generatedLeads}</strong></span>
            <span>Converted : <strong>{convertedLeads}</strong></span>
            <span>Active : <strong>{activeLeads}</strong></span>
            <span>Conversion : <strong>{conversionRate}%</strong></span>
          </div>
        </div>
      </CardBody>
    </Card>
  </Col>

  {/* Active Lead Status Card */}
  <Col md="6" className="mb-3">
    <Card className="h-100">
      <CardBody className="d-flex align-items-center justify-content-center text-center">
        {/* Hide image on mobile */}
        <img 
          src={hotImg} 
          alt="status" 
          style={{ height: 60 }} 
          className="me-3 d-none d-md-block" 
        />
        <div>
          <h5 className="fw-bold mb-1 font-size-20">Active Lead Status</h5>
          <div className="d-flex flex-wrap justify-content-center gap-5 rs-status-text">
            <span>Hot: <strong>{hotLeads}</strong></span>
            <span>Warm: <strong>{warmLeads}</strong></span>
            <span>Cold: <strong>{coldLeads}</strong></span>
            <span>Not set: <strong>{notSetLeads}</strong></span>
          </div>
        </div>
      </CardBody>
    </Card>
  </Col>
</Row>

            {/* <div className="d-flex justify-content-center gap-3 flex-wrap bg-yellow">

              {this.state.reports.map((report, key) => (
                     <div key={key} className="flex-grow-1 flex-shrink-0" style={{ flexBasis: "calc(20% - 1rem)" }}>
                      <RsCardImgv2 key={key} title={report.title} description={report.description} iconClass={report.iconClass} />
                   </div>
                  ))}

            </div> */}
            <Row>
              <Col xl="12">
               

               
                  <Row>
                    <Col lg="4" className="d-flex">
                    <Card className="border-full mt-4 w-100">
                      <CardBody className="d-flex flex-column">
                      {this.state.barchartdata && <RSBarChart filter={false} title="Monthly Lead Generation Report" {...this.state.barchartdata} />}
                      </CardBody>
                      </Card>
                    </Col>
                    <Col lg="4" className="d-flex">
                     <Card className="border-full mt-4 w-100">
                      <CardBody className="d-flex flex-column">
                     {this.state.leadSourceData && <RSPieChart filter={false} title="Leads By Source" {...this.state.leadSourceData} />} 
                     </CardBody>
                     </Card>
                    </Col>
                    <Col lg="4" className="d-flex">
                      <Card className="border-full mt-4 w-100">
  <CardBody className="d-flex flex-column">
    <div className="card-title mb-4 float-start w-100">
      Upcoming Activity

      <span className="float-end">
        {/* ✅ Tabs visible only on desktop/tablet */}
        <Nav className="projectTab actTabs d-none d-md-flex" variant="tabs">
          <NavItem>
            <NavLink
              style={{ cursor: "pointer" }}
              className={classnames({ active: this.state.activeTab === "1" })}
              onClick={() => {
                this.toggle("1");
                this.fetchLeadActivity(1);
              }}
            >
              {this.props.t("Today")}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              style={{ cursor: "pointer" }}
              className={classnames({ active: this.state.activeTab === "2" })}
              onClick={() => {
                this.toggle("2");
                this.fetchLeadActivity(2);
              }}
            >
              {this.props.t("Tomorrow")}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              style={{ cursor: "pointer" }}
              className={classnames({ active: this.state.activeTab === "3" })}
              onClick={() => {
                this.toggle("3");
                this.fetchLeadActivity(7);
              }}
            >
              {this.props.t("Next 7 Days")}
            </NavLink>
          </NavItem>
        </Nav>

        {/* ✅ Dropdown visible only on mobile */}
        <div className="d-block d-md-none">
          <select
            className="form-select"
            value={this.state.activeTab}
            onChange={(e) => {
              const val = e.target.value;
              this.toggle(val);
              this.fetchLeadActivity(val === "1" ? 1 : val === "2" ? 2 : 7);
            }}
          >
            <option value="1">{this.props.t("Today")}</option>
            <option value="2">{this.props.t("Tomorrow")}</option>
            <option value="3">{this.props.t("Next 7 Days")}</option>
          </select>
        </div>
      </span>
    </div>

    <div className="clearfix"></div>

    <div className="table-responsive">
      <table className="table mb-0">
        <thead>
          <tr>
            <th>Date</th>
            <th>Name</th>
            <th>Activity</th>
            <th className="d-none d-md-table-cell">Phone</th>
          </tr>
        </thead>
        <tbody>
          {this.state.leadActivities && this.state.leadActivities.length > 0 ? (
            this.state.leadActivities.map((activity, index) => (
              <tr key={index}>
                <td>
                  <Moment format="DD MMM YY">{activity.activityStartDate}</Moment>
                </td>
                <td>
                  <Link
                    to={`/lead/lead-detail/${activity.activityLeadId}/${activity.activityLeadGuid}`}
                  >
                    {activity.contactName}
                  </Link>
                </td>
                <td>{activity.title}</td>
                <td className="d-none d-md-table-cell">{activity.contactPhone}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4" style={{ textAlign: "center" }}>
                No activities found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </CardBody>
</Card>

                    </Col>
                  </Row>
                    
                 
              
                


                <LeadlistShort userdetail={userdetail} />
              </Col>
            </Row>
          </Container>
        </div>


                 <Offcanvas
                isOpen={this.state.isAddNew}
                direction="end"
                toggle={this.toggleAddNew}
                style={{ width: 800 }}
              >
                <OffcanvasHeader toggle={this.toggleAddNew}>
                  New Lead
                </OffcanvasHeader>
                <OffcanvasBody>
                  <CreateLead toggleAddNew={this.toggleAddNew} userdetail={userdetail} />
                </OffcanvasBody>
              </Offcanvas>


      </React.Fragment>
    );
  }
}

Dashboard.propTypes = {
  t: PropTypes.any,
  userdetail:PropTypes.object
};

export default connect()(withTranslation()(Dashboard));
